import {useAppSelector} from '@/redux-store/store';
import {openJitsiCall} from '@/services/jitsi';
import {EventData} from '@/types/event';
import {isUserDocumentManager} from '@/utils';
import {Button} from '@mui/material';
import {addMinutes, isAfter, isBefore, subMinutes} from 'date-fns';
import {useTranslation} from 'react-i18next';
import ResponsiveTypography from '../ui/responsive-typography';

interface JitsiButtonProps {
  event: EventData;
}

const JitsiButton: React.FC<JitsiButtonProps> = ({event}) => {
  const userData = useAppSelector((state) => state.userInfos.userInfos);
  const eventStart =
    event.start instanceof Date ? event.start : new Date(event.start);
  const isUserManager = isUserDocumentManager(event, userData);

  const beforeStartTime = subMinutes(eventStart, 15);
  const endTime = event.end instanceof Date ? event.end : new Date(event.end);
  const endTimePlusFiveMin = addMinutes(endTime, 5);
  const afterEndTime = isAfter(new Date(), endTimePlusFiveMin);
  const isDisabled = !isUserManager && isBefore(new Date(), beforeStartTime);
  const {t} = useTranslation();
  return (
    <>
      {!afterEndTime &&
        (isDisabled ? (
          <ResponsiveTypography
            mediumSmall
            sx={{
              marginTop: 1,
              fontWeight: 'bold'
            }}
          >
            {t('call_disabled_too_early')}
          </ResponsiveTypography>
        ) : (
          <Button
            disabled={isDisabled}
            variant="contained"
            color="secondary"
            onClick={() => openJitsiCall(event, userData, isUserManager)}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: 2,
              width: {xs: '100%', sm: 'auto'}
            }}
          >
            {t('go_to_call')}
          </Button>
        ))}
    </>
  );
};

export default JitsiButton;
